import { ReportsPage } from '@/features/reports/pages/reports-page';

const ReportsRoute = () => {
  return <ReportsPage />;
};

export default ReportsRoute;
